module.exports = __webpack_public_path__ + "static/img/IMG_20241023_121717.074325e9.jpg";